import React, { useContext } from 'react';

import { FaTiktok, FaInstagram, FaFacebookF, FaYoutube, FaApple, FaGlobe } from 'react-icons/fa';
import { FaXTwitter, FaSpotify } from 'react-icons/fa6';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import {
  List,
  ListItem,
  ListItemLink
} from './Social.styles';

const Social = () => {
  const { locale } = useContext(LanguageContext);

  return (
    <React.Fragment>
      <List color="black" isBlock>
        <ListItem color="black">
          <ListItemLink to={`https://www.oneokrock.com/${locale === AppLocale.EN ? 'en' : 'jp'}/`} target="_blank">
            <FaGlobe /> <span>{locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP} official</span>
          </ListItemLink>
        </ListItem>
      </List>
      <List color="secondary">
        <ListItem>
          <ListItemLink to="https://instagram.com/oneokrockofficial" target="_blank">
            <FaInstagram />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://www.facebook.com/ONEOKROCK" target="_blank">
            <FaFacebookF />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://twitter.com/ONEOKROCK_japan" target="_blank">
            <FaXTwitter />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://www.tiktok.com/@oneokrock_official" target="_blank">
            <FaTiktok />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://www.youtube.com/user/ONEOKROCKchannel" target="_blank">
            <FaYoutube />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://music.apple.com/jp/artist/one-ok-rock/252239625" target="_blank">
            <FaApple />
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://play.spotify.com/artist/7k73EtZwoPs516ZxE72KsO" target="_blank">
            <FaSpotify />
          </ListItemLink>
        </ListItem>
      </List>
      <List color="primary" isBlock>
        <ListItem>
          <ListItemLink to="https://instagram.com/oneokrockofficial" target="_blank">
            <FaInstagram name="instagram" /><span>TAKA</span>
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://instagram.com/oneokrockofficial" target="_blank">
            <FaInstagram name="instagram" /><span>TORU</span>
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://instagram.com/oneokrockofficial" target="_blank">
            <FaInstagram name="instagram" /><span>RYOTA</span>
          </ListItemLink>
        </ListItem>
        <ListItem>
          <ListItemLink to="https://instagram.com/oneokrockofficial" target="_blank">
            <FaInstagram name="instagram" /><span>TOMOYA</span>
          </ListItemLink>
        </ListItem>
      </List>
    </React.Fragment>
  );
};

export default Social;
